
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiEsperienzeClassiGrid extends Serenity.EntityGrid<ProdottiEsperienzeClassiRow, any> {
        protected getColumnsKey() { return ProdottiEsperienzeClassiColumns.columnsKey; }
        protected getDialogType() { return ProdottiEsperienzeClassiDialog; }
        protected getIdProperty() { return ProdottiEsperienzeClassiRow.idProperty; }
        protected getInsertPermission() { return ProdottiEsperienzeClassiRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiEsperienzeClassiRow.localTextPrefix; }
        protected getService() { return ProdottiEsperienzeClassiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}